import React from 'react';
import { useField } from 'formik';
import PhoneInput from 'react-phone-input-2';
import { Box, InputLabel, styled, Typography } from '@mui/material';
import 'react-phone-input-2/lib/style.css';

interface iFormikCountry {
  name: string;
  label?: string;
  maxHeight?: number;
}

interface iStyledPhone {
  maxHeight?: number;
}

const StyledPhone = styled(PhoneInput)<iStyledPhone>(
  ({ theme, maxHeight = 220 }) => ({
    '& > button': {
      borderColor: theme.palette.grey[300],
      boxShadow: '0 2px 3px 0 rgba(0, 0, 0, 0.05)',
      borderWidth: 1,
      borderRadius: 8,
      fontSize: 14,
      fontWeight: 500,

      '&:hover': {
        borderColor: theme.palette.grey[400],
      },

      '&:focus': {
        borderColor: theme.palette.grey[500],
        borderWidth: 1,
      },
    },

    '& > ul': {
      maxHeight,
      boxShadow: '0 7px 14px 0 #3c425714,0 3px 6px 0 #0000001f',
      border: 'none',
      borderRadius: 4,
      margin: 0,
      marginTop: 4,
      padding: 0,

      '& > div': {
        padding: 0,

        '& > input': {
          margin: 0,
          width: '100%',
          fontSize: 14,
          border: 'none',
          outline: 'none',
          borderBottom: '1px solid #eae9fa',
          borderRadius: 0,
        },
      },

      '& > li': {
        transition: 'all 0.3s ease',

        '&:hover': {
          backgroundColor: '#eae9fa',
        },
      },

      '& span': {
        fontSize: 14,
      },
    },
  })
);

const FormikCountry: React.FC<iFormikCountry> = ({
  name,
  label,
  maxHeight,
}) => {
  const [field, meta] = useField(name);

  const { error, value } = meta;
  const { onChange, onBlur } = field;

  const onPhoneChange = (value: string, data: any) => {
    onChange({ target: { value, name } });
    onChange({ target: { value: data.dialCode, name: 'supportPhoneCode' } });
  };

  return (
    <Box mt={label ? 4 : 0}>
      <InputLabel
        htmlFor={name}
        sx={{
          fontSize: 14,
          fontWeight: 500,
          color: 'text.primary',
          mb: 1,
        }}
      >
        {label}
      </InputLabel>
      <StyledPhone
        country="ca"
        value={value}
        maxHeight={maxHeight}
        onChange={onPhoneChange}
        // onChange={(phone) => onChange({ target: { value: phone, name } })}
        // onChange={(value, data, e, formatted) =>
        //   console.log({
        //     value: value.slice(data.dialCode.length),
        //     code: data.dialCode,
        //     formatted,
        //   })
        // }
        placeholder="Enter phone number"
        onBlur={onBlur}
        enableSearch
        preferredCountries={['ca', 'us']}
        inputProps={{
          name,
          id: name,
        }}
      />
      {error && (
        <Typography
          variant="body2"
          sx={{ color: 'error.main', mt: 1, fontSize: 13 }}
        >
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default FormikCountry;
